import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import IntlComponent from 'axway-react-intl';
import { Glyphicon, Button } from 'react-bootstrap';
import cn from 'classnames';

class CollapsiblePanel extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
		this.togglePanel = this.togglePanel.bind(this);
	}

	togglePanel () {
		const { onToggle } = this.props;
		onToggle && onToggle();
	}

	render() {
		const { children, header, expanded, align } = this.props;
		const alignLeft = align === 'left';
		const collapsedHeader = expanded ? 'expanded-panel-header' : 'collapsed-panel-header';
		const title = expanded ? this.intl.formatMsg('Collapse') : this.intl.formatMsg('Expand');
		let arrowDirection = expanded ? ' gg icon-GG-chevron-left' : ' gg icon-GG-chevron-right';
		if (!alignLeft) {
			arrowDirection = expanded ? ' gg icon-GG-chevron-right' : ' gg icon-GG-chevron-left';
		}
		const info = <div className={cn('heading', align)}> {header}</div>;
		const heading = (
			<div className={cn(collapsedHeader, 'border-styles', align)}>
				{ (!alignLeft && expanded) ? info : null }
				<Button
					key="collapsable-sidepanel"
					className={cn('action-btn', 'collapsible-button')}
					bsStyle="link"
					title={title}
					onClick={() => this.togglePanel()}
				>
					<Glyphicon glyph={arrowDirection} />
					<Glyphicon glyph={arrowDirection} />
				</Button>
				{ (alignLeft && expanded) ? info : null }
			</div>
		);
		return (
			<div className="collapsible-panel-container">
				{heading}
				<div className={cn('collapsible-panel-body', 'border-styles', align)}>
					{children}
				</div>
			</div>
		);
	}
}

CollapsiblePanel.propTypes = {
	/**
	 * The header text position values are 'left' or right
	 * and it will align the header text left/right
	 */
	align: PropTypes.oneOf([ 'left', 'right' ]).isRequired,
	/**
	 * The header text
	 */
	header: PropTypes.node,
	/**
	 * The Toggle callback
	 */
	onToggle: PropTypes.func,
	/**
	 * children to render
	 */
	children: PropTypes.node,
	/**
	 * Collapsed/expanded state true or false
	 */
	expanded: PropTypes.bool.isRequired

};

export default injectIntl(CollapsiblePanel);
